import api, { __isDebug } from '../Api'

let baseDomain = process.env.REACT_APP_HR_URL || null;

if (baseDomain === null) {
  const baseAdminDomain = window.location.host.toString();
  switch (baseAdminDomain) {
    case "admin.hubswitch.com":
      baseDomain = "https://hr-api.hubswitch.com";
      break;
    default:
      baseDomain = "https://hr-api-beta.hubswitch.com";
      break;
  }
}

const baseURL = __isDebug ? process.env.REACT_APP_HR_API_DEBUG_URL || baseDomain : baseDomain

const hrApi = {
  request: (url, callback = () => { }, params = {}, method = 'GET', options = {}) => {
    return api.request(url, callback, params, method, {
      baseURL, ...options
    })
  }
}

export default hrApi
